import React, { useMemo } from "react";
import { Image } from "react-bootstrap";
import { useSelector } from "react-redux";
import { getMyPafRowPermissions } from "pages/AppraisalManagment/utils/myPafHelpers";

const MyPafsRowActions = ({
  row,
  onView,
  onEdit,
  onDelete,
  processingRowId = null,
  processingAction = null,
}) => {
  const session = useSelector((state) => state.session);

  const permissions = useMemo(
    () => getMyPafRowPermissions(row, session),
    [row, session]
  );

  const isRowProcessing = processingRowId && String(processingRowId) === String(row?.id);
  const isViewLoading = isRowProcessing && processingAction === "view";
  const isEditLoading = isRowProcessing && processingAction === "edit";
  const isDeleteLoading = isRowProcessing && processingAction === "delete";

  if (!permissions.canView && !permissions.canEdit && !permissions.canDelete) {
    return <span className="text-muted font-12">—</span>;
  }

  const disabledClass = (loading) => (loading ? " opacity-50 pe-none" : "");

  return (
    <div
      className="actionClass"
      style={{ textAlign: "center", whiteSpace: "nowrap" }}
      role="group"
      aria-label="PAF actions"
    >
      {permissions.canView && (
        <Image
          src="/assets/images/view-icon.svg"
          width={20}
          className={`me-2 cursor-pointer${disabledClass(isViewLoading)}`}
          title="View"
          aria-label="View PAF"
          role="button"
          onClick={isViewLoading ? undefined : () => onView(row)}
        />
      )}

      {permissions.canEdit && (
        <Image
          src="/assets/images/edit-icon.svg"
          width={20}
          className={`me-2 cursor-pointer${disabledClass(isEditLoading)}`}
          title="Edit/Sign"
          aria-label="Edit/Sign PAF"
          role="button"
          onClick={isEditLoading ? undefined : () => onEdit(row)}
        />
      )}

      {permissions.canDelete && (
        <Image
          src="/assets/images/delete-icon.svg"
          width={20}
          className={`cursor-pointer${disabledClass(isDeleteLoading)}`}
          title="Delete"
          aria-label="Delete PAF"
          role="button"
          onClick={isDeleteLoading ? undefined : () => onDelete(row)}
        />
      )}
    </div>
  );
};

export default React.memo(MyPafsRowActions);
